import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";
import { logError } from "@/lib/log";

export const INVOICE_STATUS = {
  requested: { label: "Requested", cls: "bg-secondary text-foreground border-0" },
  invoiced: { label: "Invoice sent", cls: "bg-amber-100 text-amber-800 border-0" },
  paid: { label: "Paid", cls: "bg-accent/10 text-accent border-0" },
  cancelled: { label: "Cancelled", cls: "bg-muted text-muted-foreground border-0" },
};
export const fmtInvoiceDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function InvoiceRequestsTable() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/invoices/mine").then((r) => setItems(r.data)).catch((e) => { logError("invoices", e); setItems([]); }); }, []);
  if (!items?.length) return null;
  return (
    <section className="rounded-2xl border border-border bg-card shadow-sm overflow-hidden" data-testid="billing-invoice-requests">
      <div className="px-6 py-4 border-b border-border flex items-center gap-2">
        <FileText className="w-4 h-4 text-primary" />
        <h2 className="font-display font-bold">Invoice requests</h2>
        <span className="text-xs text-muted-foreground ml-auto">14-day terms · bank transfer</span>
      </div>
      <ul className="divide-y divide-border">
        {items.map((inv) => {
          const st = INVOICE_STATUS[inv.status] || INVOICE_STATUS.requested;
          return (
            <li key={inv.id} className="px-6 py-3 flex items-center justify-between gap-4 text-sm" data-testid={`invoice-request-${inv.id}`}>
              <div className="min-w-0">
                <p className="font-medium truncate">{inv.title}</p>
                <p className="text-xs text-muted-foreground">Requested {fmtInvoiceDate(inv.created_at)}{inv.invoice_number ? ` · Invoice ${inv.invoice_number}` : ""}{inv.po_number ? ` · PO ${inv.po_number}` : ""}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="font-semibold">£{Number(inv.amount_gbp).toLocaleString("en-GB")}</span>
                <Badge className={st.cls}>{st.label}</Badge>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
